export default "__VITE_ASSET__CwGfCWHs__"